import { memo as e, useMemo as r, useState as i, useCallback as n, createElement as t, Fragment as o, forwardRef as a, useRef as s, useEffect as l } from "react";
import { useTheme as u, lineCurvePropType as d, blendModePropType as c, motionPropTypes as f, defsPropTypes as p, curveFromProp as h, useValueFormatter as y, useMotionConfig as b, useAnimatedPath as g, getLabelGenerator as m, DotsItem as v, withContainer as x, useDimensions as R, CartesianMarkers as q, bindDefs as O, SvgWrapper as S, ResponsiveWrapper as C, getRelativeCursor as T, isCursorInRect as M } from "@nivo/core";
import { ordinalColorsPropType as w, useOrdinalColorScale as B, useInheritedColor as k } from "@nivo/colors";
import { axisPropType as W, Grid as G, Axes as L, renderGridLinesToCanvas as P, renderAxesToCanvas as j } from "@nivo/axes";
import { LegendPropShape as F, BoxLegendSvg as V, renderLegendToCanvas as E } from "@nivo/legends";
import { BasicTooltip as Y, TableTooltip as D, Chip as X, useTooltip as z, Crosshair as A } from "@nivo/tooltip";
import { line as H, area as I } from "d3-shape";
import { computeXYScalesForSeries as J } from "@nivo/scales";
import K from "prop-types";
import { jsx as N, jsxs as Q } from "react/jsx-runtime";
import { useSpring as U, animated as Z } from "@react-spring/web";
import { Mesh as $, useVoronoiMesh as _, renderVoronoiToCanvas as ee, renderVoronoiCellToCanvas as re } from "@nivo/voronoi";
function ie() {
    return ie = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var i = arguments[r];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
        }
        return e;
    }, ie.apply(this, arguments);
}
var ne = function ne(e) {
    var r = e.point;
    return N(Y, {
        id: Q("span", {
            children: [
                "x: ",
                N("strong", {
                    children: r.data.xFormatted
                }),
                ", y:",
                " ",
                N("strong", {
                    children: r.data.yFormatted
                })
            ]
        }),
        enableChip: !0,
        color: r.serieColor
    });
};
ne.propTypes = {
    point: K.object.isRequired
};
var te = e(ne), oe = function oe(e) {
    var r = e.slice, i = e.axis, n = u(), t = "x" === i ? "y" : "x";
    return N(D, {
        rows: r.points.map(function(e) {
            return [
                N(X, {
                    color: e.serieColor,
                    style: n.tooltip.chip
                }, "chip"),
                e.serieId,
                N("span", {
                    style: n.tooltip.tableCellValue,
                    children: e.data[t + "Formatted"]
                }, "value")
            ];
        })
    });
};
oe.propTypes = {
    slice: K.object.isRequired,
    axis: K.oneOf([
        "x",
        "y"
    ]).isRequired
};
var ae = e(oe), se = {
    data: K.arrayOf(K.shape({
        id: K.oneOfType([
            K.string,
            K.number
        ]).isRequired,
        data: K.arrayOf(K.shape({
            x: K.oneOfType([
                K.number,
                K.string,
                K.instanceOf(Date)
            ]),
            y: K.oneOfType([
                K.number,
                K.string,
                K.instanceOf(Date)
            ])
        })).isRequired
    })).isRequired,
    xScale: K.object.isRequired,
    xFormat: K.oneOfType([
        K.func,
        K.string
    ]),
    yScale: K.object.isRequired,
    yFormat: K.oneOfType([
        K.func,
        K.string
    ]),
    layers: K.arrayOf(K.oneOfType([
        K.oneOf([
            "grid",
            "markers",
            "axes",
            "areas",
            "crosshair",
            "lines",
            "slices",
            "points",
            "mesh",
            "legends"
        ]),
        K.func
    ])).isRequired,
    curve: d.isRequired,
    axisTop: W,
    axisRight: W,
    axisBottom: W,
    axisLeft: W,
    enableGridX: K.bool.isRequired,
    enableGridY: K.bool.isRequired,
    gridXValues: K.oneOfType([
        K.number,
        K.arrayOf(K.oneOfType([
            K.number,
            K.string,
            K.instanceOf(Date)
        ]))
    ]),
    gridYValues: K.oneOfType([
        K.number,
        K.arrayOf(K.oneOfType([
            K.number,
            K.string,
            K.instanceOf(Date)
        ]))
    ]),
    enablePoints: K.bool.isRequired,
    pointSymbol: K.func,
    pointSize: K.number.isRequired,
    pointColor: K.any.isRequired,
    pointBorderWidth: K.number.isRequired,
    pointBorderColor: K.any.isRequired,
    enablePointLabel: K.bool.isRequired,
    pointLabel: K.oneOfType([
        K.string,
        K.func
    ]).isRequired,
    markers: K.arrayOf(K.shape({
        axis: K.oneOf([
            "x",
            "y"
        ]).isRequired,
        value: K.oneOfType([
            K.number,
            K.string,
            K.instanceOf(Date)
        ]).isRequired,
        style: K.object
    })),
    colors: w.isRequired,
    enableArea: K.bool.isRequired,
    areaOpacity: K.number.isRequired,
    areaBlendMode: c.isRequired,
    areaBaselineValue: K.oneOfType([
        K.number,
        K.string,
        K.instanceOf(Date)
    ]).isRequired,
    lineWidth: K.number.isRequired,
    legends: K.arrayOf(K.shape(F)).isRequired,
    isInteractive: K.bool.isRequired,
    debugMesh: K.bool.isRequired,
    tooltip: K.oneOfType([
        K.func,
        K.object
    ]).isRequired,
    enableSlices: K.oneOf([
        "x",
        "y",
        !1
    ]).isRequired,
    debugSlices: K.bool.isRequired,
    sliceTooltip: K.oneOfType([
        K.func,
        K.object
    ]).isRequired,
    enableCrosshair: K.bool.isRequired,
    crosshairType: K.string.isRequired
}, le = ie({}, se, {
    enablePointLabel: K.bool.isRequired,
    role: K.string.isRequired,
    useMesh: K.bool.isRequired
}, f, p), ue = ie({
    pixelRatio: K.number.isRequired
}, se), de = {
    curve: "linear",
    xScale: {
        type: "point"
    },
    yScale: {
        type: "linear",
        min: 0,
        max: "auto"
    },
    layers: [
        "grid",
        "markers",
        "axes",
        "areas",
        "crosshair",
        "lines",
        "points",
        "slices",
        "mesh",
        "legends"
    ],
    axisBottom: {},
    axisLeft: {},
    enableGridX: !0,
    enableGridY: !0,
    enablePoints: !0,
    pointSize: 6,
    pointColor: {
        from: "color"
    },
    pointBorderWidth: 0,
    pointBorderColor: {
        theme: "background"
    },
    enablePointLabel: !1,
    pointLabel: "yFormatted",
    colors: {
        scheme: "nivo"
    },
    enableArea: !1,
    areaBaselineValue: 0,
    areaOpacity: .2,
    areaBlendMode: "normal",
    lineWidth: 2,
    legends: [],
    isInteractive: !0,
    tooltip: te,
    enableSlices: !1,
    debugSlices: !1,
    sliceTooltip: ae,
    debugMesh: !1,
    enableCrosshair: !0,
    crosshairType: "bottom-left"
}, ce = ie({}, de, {
    enablePointLabel: !1,
    useMesh: !1,
    animate: !0,
    motionConfig: "gentle",
    defs: [],
    fill: [],
    role: "img"
}), fe = ie({}, de, {
    pixelRatio: "undefined" != typeof window && window.devicePixelRatio || 1
}), pe = function pe(e) {
    var i = e.curve;
    return r(function() {
        return H().defined(function(e) {
            return null !== e.x && null !== e.y;
        }).x(function(e) {
            return e.x;
        }).y(function(e) {
            return e.y;
        }).curve(h(i));
    }, [
        i
    ]);
}, he = function he(e) {
    var i = e.curve, n = e.yScale, t = e.areaBaselineValue;
    return r(function() {
        return I().defined(function(e) {
            return null !== e.x && null !== e.y;
        }).x(function(e) {
            return e.x;
        }).y1(function(e) {
            return e.y;
        }).curve(h(i)).y0(n(t));
    }, [
        i,
        n,
        t
    ]);
}, ye = function ye(e) {
    var i = e.enableSlices, n = e.points, t = e.width, o = e.height;
    return r(function() {
        if (!1 === i) return [];
        if ("x" === i) {
            var _$e = new Map;
            return n.forEach(function(r) {
                null !== r.data.x && null !== r.data.y && (_$e.has(r.x) ? _$e.get(r.x).push(r) : _$e.set(r.x, [
                    r
                ]));
            }), Array.from(_$e.entries()).sort(function(e, r) {
                return e[0] - r[0];
            }).map(function(e, r, i) {
                var n, _$a = e[0], s = e[1], l = i[r - 1], u = i[r + 1];
                return {
                    id: _$a,
                    x0: n = l ? _$a - (_$a - l[0]) / 2 : _$a,
                    x: _$a,
                    y0: 0,
                    y: 0,
                    width: u ? _$a - n + (u[0] - _$a) / 2 : t - n,
                    height: o,
                    points: s.reverse()
                };
            });
        }
        if ("y" === i) {
            var _$r = new Map;
            return n.forEach(function(e) {
                null !== e.data.x && null !== e.data.y && (_$r.has(e.y) ? _$r.get(e.y).push(e) : _$r.set(e.y, [
                    e
                ]));
            }), Array.from(_$r.entries()).sort(function(e, r) {
                return e[0] - r[0];
            }).map(function(e, r, i) {
                var n, _$a, s = e[0], l = e[1], u = i[r - 1], _$d = i[r + 1];
                return n = u ? s - (s - u[0]) / 2 : s, _$a = _$d ? s - n + (_$d[0] - s) / 2 : o - n, {
                    id: s,
                    x0: 0,
                    x: 0,
                    y0: n,
                    y: s,
                    width: t,
                    height: _$a,
                    points: l.reverse()
                };
            });
        }
    }, [
        i,
        n
    ]);
}, be = function be(e) {
    var t = e.data, o = e.xScale, _$a = void 0 === o ? ce.xScale : o, s = e.xFormat, l = e.yScale, _$d = void 0 === l ? ce.yScale : l, _$c = e.yFormat, _$f = e.width, _$p = e.height, h = e.colors, b = void 0 === h ? ce.colors : h, g = e.curve, m = void 0 === g ? ce.curve : g, v = e.areaBaselineValue, _$x = void 0 === v ? ce.areaBaselineValue : v, R = e.pointColor, q = void 0 === R ? ce.pointColor : R, O = e.pointBorderColor, S = void 0 === O ? ce.pointBorderColor : O, C = e.enableSlices, T = void 0 === C ? ce.enableSlicesTooltip : C, M = y(s), _$w = y(_$c), _$W = B(b, "id"), G = u(), L = k(q, G), P = k(S, G), j = i([]), _$F = j[0], V = j[1], E = r(function() {
        return J(t.filter(function(e) {
            return -1 === _$F.indexOf(e.id);
        }), _$a, _$d, _$f, _$p);
    }, [
        t,
        _$F,
        _$a,
        _$d,
        _$f,
        _$p
    ]), Y = E.xScale, D = E.yScale, X = E.series, z = r(function() {
        var _$e = t.map(function(e) {
            return {
                id: e.id,
                label: e.id,
                color: _$W(e)
            };
        }), _$r = _$e.map(function(e) {
            return ie({}, X.find(function(r) {
                return r.id === e.id;
            }), {
                color: e.color
            });
        }).filter(function(e) {
            return Boolean(e.id);
        });
        return {
            legendData: _$e.map(function(e) {
                return ie({}, e, {
                    hidden: !_$r.find(function(r) {
                        return r.id === e.id;
                    })
                });
            }).reverse(),
            series: _$r
        };
    }, [
        t,
        X,
        _$W
    ]), A = z.legendData, H = z.series, I = n(function(e) {
        V(function(r) {
            return r.indexOf(e) > -1 ? r.filter(function(r) {
                return r !== e;
            }) : [].concat(r, [
                e
            ]);
        });
    }, []), _$K = function(e) {
        var _$i = e.series, _$n = e.getPointColor, t = e.getPointBorderColor, o = e.formatX, _$a = e.formatY;
        return r(function() {
            return _$i.reduce(function(e, r) {
                return [].concat(e, r.data.filter(function(e) {
                    return null !== e.position.x && null !== e.position.y;
                }).map(function(i, s) {
                    var l = {
                        id: r.id + "." + s,
                        index: e.length + s,
                        serieId: r.id,
                        serieColor: r.color,
                        x: i.position.x,
                        y: i.position.y
                    };
                    return l.color = _$n(r), l.borderColor = t(l), l.data = ie({}, i.data, {
                        xFormatted: o(i.data.x),
                        yFormatted: _$a(i.data.y)
                    }), l;
                }));
            }, []);
        }, [
            _$i,
            _$n,
            t,
            o,
            _$a
        ]);
    }({
        series: H,
        getPointColor: L,
        getPointBorderColor: P,
        formatX: M,
        formatY: _$w
    }), N = ye({
        enableSlices: T,
        points: _$K,
        width: _$f,
        height: _$p
    });
    return {
        legendData: A,
        toggleSerie: I,
        lineGenerator: pe({
            curve: m
        }),
        areaGenerator: he({
            curve: m,
            yScale: D,
            areaBaselineValue: _$x
        }),
        getColor: _$W,
        series: H,
        xScale: Y,
        yScale: D,
        slices: N,
        points: _$K
    };
}, ge = function ge(e) {
    var r = e.areaBlendMode, i = e.areaOpacity, n = e.color, t = e.fill, o = e.path, _$a = b(), s = _$a.animate, l = _$a.config, u = g(o), _$d = U({
        color: n,
        config: l,
        immediate: !s
    });
    return N(Z.path, {
        d: u,
        fill: t || _$d.color,
        fillOpacity: i,
        strokeWidth: 0,
        style: {
            mixBlendMode: r
        }
    });
};
ge.propTypes = {
    areaBlendMode: c.isRequired,
    areaOpacity: K.number.isRequired,
    color: K.string,
    fill: K.string,
    path: K.string.isRequired
};
var me = function me(e) {
    var r = e.areaGenerator, i = e.areaOpacity, n = e.areaBlendMode, t = e.lines.slice(0).reverse();
    return N("g", {
        children: t.map(function(e) {
            return N(ge, ie({
                path: r(e.data.map(function(e) {
                    return e.position;
                }))
            }, ie({
                areaOpacity: i,
                areaBlendMode: n
            }, e)), e.id);
        })
    });
};
me.propTypes = {
    areaGenerator: K.func.isRequired,
    areaOpacity: K.number.isRequired,
    areaBlendMode: c.isRequired,
    lines: K.arrayOf(K.object).isRequired
};
var ve = e(me), xe = function xe(e) {
    var i = e.lineGenerator, n = e.points, t = e.color, o = e.thickness, _$a = r(function() {
        return i(n);
    }, [
        i,
        n
    ]), s = g(_$a);
    return N(Z.path, {
        d: s,
        fill: "none",
        strokeWidth: o,
        stroke: t
    });
};
xe.propTypes = {
    points: K.arrayOf(K.shape({
        x: K.oneOfType([
            K.string,
            K.number
        ]),
        y: K.oneOfType([
            K.string,
            K.number
        ])
    })),
    lineGenerator: K.func.isRequired,
    color: K.string.isRequired,
    thickness: K.number.isRequired
};
var Re = e(xe), qe = function qe(e) {
    var r = e.lines, i = e.lineGenerator, n = e.lineWidth;
    return r.slice(0).reverse().map(function(e) {
        var r = e.id, t = e.data, o = e.color;
        return N(Re, {
            id: r,
            points: t.map(function(e) {
                return e.position;
            }),
            lineGenerator: i,
            color: o,
            thickness: n
        }, r);
    });
};
qe.propTypes = {
    lines: K.arrayOf(K.shape({
        id: K.oneOfType([
            K.string,
            K.number
        ]).isRequired,
        color: K.string.isRequired,
        data: K.arrayOf(K.shape({
            data: K.shape({
                x: K.oneOfType([
                    K.string,
                    K.number,
                    K.instanceOf(Date)
                ]),
                y: K.oneOfType([
                    K.string,
                    K.number,
                    K.instanceOf(Date)
                ])
            }).isRequired,
            position: K.shape({
                x: K.number,
                y: K.number
            }).isRequired
        })).isRequired
    })).isRequired,
    lineWidth: K.number.isRequired,
    lineGenerator: K.func.isRequired
};
var Oe = e(qe), Se = function Se(e) {
    var r = e.slice, i = e.axis, o = e.debug, _$a = e.tooltip, s = e.isCurrent, l = e.setCurrent, u = z(), _$d = u.showTooltipFromEvent, _$c = u.hideTooltip, _$f = n(function(e) {
        _$d(t(_$a, {
            slice: r,
            axis: i
        }), e, "right"), l(r);
    }, [
        _$d,
        _$a,
        r
    ]), _$p = n(function(e) {
        _$d(t(_$a, {
            slice: r,
            axis: i
        }), e, "right");
    }, [
        _$d,
        _$a,
        r
    ]), h = n(function() {
        _$c(), l(null);
    }, [
        _$c
    ]);
    return N("rect", {
        x: r.x0,
        y: r.y0,
        width: r.width,
        height: r.height,
        stroke: "red",
        strokeWidth: o ? 1 : 0,
        strokeOpacity: .75,
        fill: "red",
        fillOpacity: s && o ? .35 : 0,
        onMouseEnter: _$f,
        onMouseMove: _$p,
        onMouseLeave: h
    });
};
Se.propTypes = {
    slice: K.object.isRequired,
    axis: K.oneOf([
        "x",
        "y"
    ]).isRequired,
    debug: K.bool.isRequired,
    height: K.number.isRequired,
    tooltip: K.oneOfType([
        K.func,
        K.object
    ]),
    isCurrent: K.bool.isRequired,
    setCurrent: K.func.isRequired
};
var Ce = e(Se), Te = function Te(e) {
    var r = e.slices, i = e.axis, n = e.debug, t = e.height, o = e.tooltip, _$a = e.current, s = e.setCurrent;
    return r.map(function(e) {
        return N(Ce, {
            slice: e,
            axis: i,
            debug: n,
            height: t,
            tooltip: o,
            setCurrent: s,
            isCurrent: null !== _$a && _$a.id === e.id
        }, e.id);
    });
};
Te.propTypes = {
    slices: K.arrayOf(K.shape({
        id: K.oneOfType([
            K.number,
            K.string,
            K.instanceOf(Date)
        ]).isRequired,
        x: K.number.isRequired,
        y: K.number.isRequired,
        points: K.arrayOf(K.object).isRequired
    })).isRequired,
    axis: K.oneOf([
        "x",
        "y"
    ]).isRequired,
    debug: K.bool.isRequired,
    height: K.number.isRequired,
    tooltip: K.oneOfType([
        K.func,
        K.object
    ]).isRequired,
    current: K.object,
    setCurrent: K.func.isRequired
};
var Me = e(Te), we = function we(e) {
    var r = e.points, i = e.symbol, n = e.size, t = e.borderWidth, o = e.enableLabel, _$a = e.label, s = e.labelYOffset, l = u(), _$d = m(_$a), _$c = r.reverse().map(function(e) {
        return {
            id: e.id,
            x: e.x,
            y: e.y,
            datum: e.data,
            fill: e.color,
            stroke: e.borderColor,
            label: o ? _$d(e.data) : null
        };
    });
    return N("g", {
        children: _$c.map(function(e) {
            return N(v, {
                x: e.x,
                y: e.y,
                datum: e.datum,
                symbol: i,
                size: n,
                color: e.fill,
                borderWidth: t,
                borderColor: e.stroke,
                label: e.label,
                labelYOffset: s,
                theme: l
            }, e.id);
        })
    });
};
we.propTypes = {
    points: K.arrayOf(K.object),
    symbol: K.func,
    size: K.number.isRequired,
    color: K.func.isRequired,
    borderWidth: K.number.isRequired,
    borderColor: K.func.isRequired,
    enableLabel: K.bool.isRequired,
    label: K.oneOfType([
        K.string,
        K.func
    ]).isRequired,
    labelYOffset: K.number
};
var Be = e(we), ke = function ke(e) {
    var r = e.points, i = e.width, o = e.height, _$a = e.margin, s = e.setCurrent, l = e.onMouseEnter, u = e.onMouseMove, _$d = e.onMouseLeave, _$c = e.onClick, _$f = e.tooltip, _$p = e.debug, h = z(), y = h.showTooltipAt, b = h.hideTooltip, g = n(function(e, r) {
        y(t(_$f, {
            point: e
        }), [
            e.x + _$a.left,
            e.y + _$a.top
        ], "top"), s(e), l && l(e, r);
    }, [
        s,
        y,
        _$f,
        l,
        _$a
    ]), m = n(function(e, r) {
        y(t(_$f, {
            point: e
        }), [
            e.x + _$a.left,
            e.y + _$a.top
        ], "top"), s(e), u && u(e, r);
    }, [
        s,
        y,
        _$f,
        u
    ]), v = n(function(e, r) {
        b(), s(null), _$d && _$d(e, r);
    }, [
        b,
        s,
        _$d
    ]), _$x = n(function(e, r) {
        _$c && _$c(e, r);
    }, [
        _$c
    ]);
    return N($, {
        nodes: r,
        width: i,
        height: o,
        onMouseEnter: g,
        onMouseMove: m,
        onMouseLeave: v,
        onClick: _$x,
        debug: _$p
    });
};
ke.propTypes = {
    points: K.arrayOf(K.object).isRequired,
    width: K.number.isRequired,
    height: K.number.isRequired,
    margin: K.object.isRequired,
    setCurrent: K.func.isRequired,
    onMouseEnter: K.func,
    onMouseMove: K.func,
    onMouseLeave: K.func,
    onClick: K.func,
    tooltip: K.oneOfType([
        K.func,
        K.object
    ]).isRequired,
    debug: K.bool.isRequired
};
var We = e(ke), Ge = function Ge(e) {
    var r = e.data, n = e.xScale, t = e.xFormat, _$a = e.yScale, s = e.yFormat, l = e.layers, _$d = e.curve, _$c = e.areaBaselineValue, _$f = e.colors, _$p = e.margin, h = e.width, y = e.height, b = e.axisTop, g = e.axisRight, m = e.axisBottom, v = e.axisLeft, _$x = e.enableGridX, C = e.enableGridY, T = e.gridXValues, M = e.gridYValues, _$w = e.lineWidth, B = e.enableArea, _$W = e.areaOpacity, P = e.areaBlendMode, j = e.enablePoints, _$F = e.pointSymbol, E = e.pointSize, Y = e.pointColor, D = e.pointBorderWidth, X = e.pointBorderColor, z = e.enablePointLabel, H = e.pointLabel, I = e.pointLabelYOffset, J = e.defs, _$K = e.fill, Q = e.markers, U = e.legends, Z = e.isInteractive, $ = e.useMesh, _ = e.debugMesh, ee = e.onMouseEnter, re = e.onMouseMove, ne = e.onMouseLeave, te = e.onClick, oe = e.tooltip, ae = e.enableSlices, se = e.debugSlices, le = e.sliceTooltip, ue = e.enableCrosshair, de = e.crosshairType, ce = e.role, fe = R(h, y, _$p), pe = fe.margin, he = fe.innerWidth, ye = fe.innerHeight, ge = fe.outerWidth, me = fe.outerHeight, xe = be({
        data: r,
        xScale: n,
        xFormat: t,
        yScale: _$a,
        yFormat: s,
        width: he,
        height: ye,
        colors: _$f,
        curve: _$d,
        areaBaselineValue: _$c,
        pointColor: Y,
        pointBorderColor: X,
        enableSlices: ae
    }), Re = xe.legendData, qe = xe.toggleSerie, Se = xe.lineGenerator, Ce = xe.areaGenerator, Te = xe.series, we = xe.xScale, ke = xe.yScale, Ge = xe.slices, Le = xe.points, Pe = u(), je = k(Y, Pe), Fe = k(X, Pe), Ve = i(null), Ee = Ve[0], Ye = Ve[1], De = i(null), Xe = De[0], ze = De[1], Ae = {
        grid: N(G, {
            theme: Pe,
            width: he,
            height: ye,
            xScale: _$x ? we : null,
            yScale: C ? ke : null,
            xValues: T,
            yValues: M
        }, "grid"),
        markers: N(q, {
            markers: Q,
            width: he,
            height: ye,
            xScale: we,
            yScale: ke,
            theme: Pe
        }, "markers"),
        axes: N(L, {
            xScale: we,
            yScale: ke,
            width: he,
            height: ye,
            theme: Pe,
            top: b,
            right: g,
            bottom: m,
            left: v
        }, "axes"),
        areas: null,
        lines: N(Oe, {
            lines: Te,
            lineGenerator: Se,
            lineWidth: _$w
        }, "lines"),
        slices: null,
        points: null,
        crosshair: null,
        mesh: null,
        legends: U.map(function(e, r) {
            return N(V, ie({}, e, {
                containerWidth: he,
                containerHeight: ye,
                data: e.data || Re,
                theme: Pe,
                toggleSerie: e.toggleSerie ? qe : void 0
            }), "legend." + r);
        })
    }, He = O(J, Te, _$K);
    return B && (Ae.areas = N(ve, {
        areaGenerator: Ce,
        areaOpacity: _$W,
        areaBlendMode: P,
        lines: Te
    }, "areas")), Z && !1 !== ae && (Ae.slices = N(Me, {
        slices: Ge,
        axis: ae,
        debug: se,
        height: ye,
        tooltip: le,
        current: Xe,
        setCurrent: ze
    }, "slices")), j && (Ae.points = N(Be, {
        points: Le,
        symbol: _$F,
        size: E,
        color: je,
        borderWidth: D,
        borderColor: Fe,
        enableLabel: z,
        label: H,
        labelYOffset: I
    }, "points")), Z && ue && (null !== Ee && (Ae.crosshair = N(A, {
        width: he,
        height: ye,
        x: Ee.x,
        y: Ee.y,
        type: de
    }, "crosshair")), null !== Xe && (Ae.crosshair = N(A, {
        width: he,
        height: ye,
        x: Xe.x,
        y: Xe.y,
        type: ae
    }, "crosshair"))), Z && $ && !1 === ae && (Ae.mesh = N(We, {
        points: Le,
        width: he,
        height: ye,
        margin: pe,
        current: Ee,
        setCurrent: Ye,
        onMouseEnter: ee,
        onMouseMove: re,
        onMouseLeave: ne,
        onClick: te,
        tooltip: oe,
        debug: _
    }, "mesh")), N(S, {
        defs: He,
        width: ge,
        height: me,
        margin: pe,
        role: ce,
        children: l.map(function(r, i) {
            return "function" == typeof r ? N(o, {
                children: r(ie({}, e, {
                    innerWidth: he,
                    innerHeight: ye,
                    series: Te,
                    slices: Ge,
                    points: Le,
                    xScale: we,
                    yScale: ke,
                    lineGenerator: Se,
                    areaGenerator: Ce,
                    currentPoint: Ee,
                    setCurrentPoint: Ye,
                    currentSlice: Xe,
                    setCurrentSlice: ze
                }))
            }, i) : Ae[r];
        })
    });
};
Ge.propTypes = le, Ge.defaultProps = ce;
var Le = x(Ge), Pe = function Pe(e) {
    return N(C, {
        children: function children(r) {
            var i = r.width, n = r.height;
            return N(Le, ie({
                width: i,
                height: n
            }, e));
        }
    });
}, je = function je(e) {
    var r = e.width, o = e.height, _$a = e.margin, _$d = e.pixelRatio, _$c = e.data, _$f = e.xScale, _$p = e.xFormat, h = e.yScale, y = e.yFormat, b = e.curve, g = e.layers, m = e.colors, v = e.lineWidth, _$x = e.enableArea, q = e.areaBaselineValue, O = e.areaOpacity, S = e.enablePoints, C = e.pointSize, _$w = e.pointColor, B = e.pointBorderWidth, k = e.pointBorderColor, _$W = e.enableGridX, G = e.gridXValues, L = e.enableGridY, _$F = e.gridYValues, V = e.axisTop, Y = e.axisRight, D = e.axisBottom, X = e.axisLeft, A = e.legends, H = e.isInteractive, I = e.debugMesh, J = e.onMouseLeave, _$K = e.onClick, Q = e.tooltip, U = e.canvasRef, Z = s(null), $ = R(r, o, _$a), ne = $.margin, te = $.innerWidth, oe = $.innerHeight, ae = $.outerWidth, se = $.outerHeight, le = u(), ue = i(null), de = ue[0], ce = ue[1], fe = be({
        data: _$c,
        xScale: _$f,
        xFormat: _$p,
        yScale: h,
        yFormat: y,
        width: te,
        height: oe,
        colors: m,
        curve: b,
        areaBaselineValue: q,
        pointColor: _$w,
        pointBorderColor: k
    }), pe = fe.lineGenerator, he = fe.areaGenerator, ye = fe.series, ge = fe.xScale, me = fe.yScale, ve = fe.points, xe = _({
        points: ve,
        width: te,
        height: oe,
        debug: I
    }), Re = xe.delaunay, qe = xe.voronoi;
    l(function() {
        U && (U.current = Z.current), Z.current.width = ae * _$d, Z.current.height = se * _$d;
        var _$e = Z.current.getContext("2d");
        _$e.scale(_$d, _$d), _$e.fillStyle = le.background, _$e.fillRect(0, 0, ae, se), _$e.translate(ne.left, ne.top), g.forEach(function(r) {
            if ("function" == typeof r && r({
                ctx: _$e,
                innerWidth: te,
                innerHeight: oe,
                series: ye,
                points: ve,
                xScale: ge,
                yScale: me,
                lineWidth: v,
                lineGenerator: pe,
                areaGenerator: he,
                currentPoint: de,
                setCurrentPoint: ce
            }), "grid" === r && le.grid.line.strokeWidth > 0 && (_$e.lineWidth = le.grid.line.strokeWidth, _$e.strokeStyle = le.grid.line.stroke, _$W && P(_$e, {
                width: te,
                height: oe,
                scale: ge,
                axis: "x",
                values: G
            }), L && P(_$e, {
                width: te,
                height: oe,
                scale: me,
                axis: "y",
                values: _$F
            })), "axes" === r && j(_$e, {
                xScale: ge,
                yScale: me,
                width: te,
                height: oe,
                top: V,
                right: Y,
                bottom: D,
                left: X,
                theme: le
            }), "areas" === r && !0 === _$x && (_$e.save(), _$e.globalAlpha = O, he.context(_$e), ye.forEach(function(r) {
                _$e.fillStyle = r.color, _$e.beginPath(), he(r.data.map(function(e) {
                    return e.position;
                })), _$e.fill();
            }), _$e.restore()), "lines" === r && (pe.context(_$e), ye.forEach(function(r) {
                _$e.strokeStyle = r.color, _$e.lineWidth = v, _$e.beginPath(), pe(r.data.map(function(e) {
                    return e.position;
                })), _$e.stroke();
            })), "points" === r && !0 === S && C > 0 && ve.forEach(function(r) {
                _$e.fillStyle = r.color, _$e.beginPath(), _$e.arc(r.x, r.y, C / 2, 0, 2 * Math.PI), _$e.fill(), B > 0 && (_$e.strokeStyle = r.borderColor, _$e.lineWidth = B, _$e.stroke());
            }), "mesh" === r && !0 === I && (ee(_$e, qe), de && re(_$e, qe, de.index)), "legends" === r) {
                var _$i = ye.map(function(e) {
                    return {
                        id: e.id,
                        label: e.id,
                        color: e.color
                    };
                }).reverse();
                A.forEach(function(r) {
                    E(_$e, ie({}, r, {
                        data: r.data || _$i,
                        containerWidth: te,
                        containerHeight: oe,
                        theme: le
                    }));
                });
            }
        });
    }, [
        Z,
        ae,
        se,
        g,
        le,
        pe,
        ye,
        ge,
        me,
        _$W,
        G,
        L,
        _$F,
        V,
        Y,
        D,
        X,
        A,
        ve,
        S,
        C,
        de
    ]);
    var Oe = n(function(e) {
        var r = T(Z.current, e), _$i = r[0], _$n = r[1];
        if (!M(ne.left, ne.top, te, oe, _$i, _$n)) return null;
        var t = Re.find(_$i - ne.left, _$n - ne.top);
        return ve[t];
    }, [
        Z,
        ne,
        te,
        oe,
        Re
    ]), Se = z(), Ce = Se.showTooltipFromEvent, Te = Se.hideTooltip, Me = n(function(e) {
        var r = Oe(e);
        ce(r), r ? Ce(t(Q, {
            point: r
        }), e) : Te();
    }, [
        Oe,
        ce,
        Ce,
        Te,
        Q
    ]), we = n(function(e) {
        Te(), ce(null), de && J && J(de, e);
    }, [
        Te,
        ce,
        J
    ]), Be = n(function(e) {
        if (_$K) {
            var r = Oe(e);
            r && _$K(r, e);
        }
    }, [
        Oe,
        _$K
    ]);
    return N("canvas", {
        ref: Z,
        width: ae * _$d,
        height: se * _$d,
        style: {
            width: ae,
            height: se,
            cursor: H ? "auto" : "normal"
        },
        onMouseEnter: H ? Me : void 0,
        onMouseMove: H ? Me : void 0,
        onMouseLeave: H ? we : void 0,
        onClick: H ? Be : void 0
    });
};
je.propTypes = ue, je.defaultProps = fe;
var Fe = x(je), Ve = a(function(e, r) {
    return N(Fe, ie({}, e, {
        canvasRef: r
    }));
}), Ee = a(function(e, r) {
    return N(C, {
        children: function children(i) {
            var n = i.width, t = i.height;
            return N(Ve, ie({
                width: n,
                height: t
            }, e, {
                ref: r
            }));
        }
    });
});
export { Le as Line, Ve as LineCanvas, fe as LineCanvasDefaultProps, ue as LineCanvasPropTypes, ce as LineDefaultProps, le as LinePropTypes, Pe as ResponsiveLine, Ee as ResponsiveLineCanvas, he as useAreaGenerator, be as useLine, pe as useLineGenerator, ye as useSlices }; //# sourceMappingURL=nivo-line.es.js.map
